export var apiEndPoint = 'https://api-fempulse.kesemsolutions.com/';
// export var apiEndPoint = 'http://localhost:4000/';

export var apiLoginUser = apiEndPoint + 'login/authenticate';
export var apiSetting = apiEndPoint + 'setting/update-json';
export var apiDeviceData = apiEndPoint + 'devices';
export var apiDeviceSession = apiEndPoint + 'sessions/';
export var apiNotification = apiEndPoint + 'notifications';
export var firebaseApi = "https://fcm.googleapis.com/fcm/send";
